<template>
  <report-details-page :report-code="REPORT_CODES.MONEY_MOVE" />
</template>

<script>
import ReportDetailsPage from '../ReportDetailsPage.vue'
import { REPORT_CODES } from '../utils/reportMetadata'

export default {
  name: 'create_document_report_money_move',
  components: {
    ReportDetailsPage
  },
  data() {
    return {
      REPORT_CODES
    }
  }
}
</script>
